import { Component } from '@angular/core';
import { UserRoleService } from '../../../services/userRole.service';
import { TranslatePipe } from '@ngx-translate/core';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { CertificateOverviewComponent } from '../certificate-overview/certificate-overview.component';
import { CertificateQueryComponent } from '../certificate-query/certificate-query.component';

@Component({
  selector: 'report-card-contribution',
  templateUrl: './report-card-contribution.component.html',
  styleUrls: ['./report-card-contribution.component.scss'],
  standalone: true,
  imports: [
    TranslatePipe,
    MatTabGroup,
    MatTab,
    CertificateOverviewComponent,
    CertificateQueryComponent,
  ],
  styles: [],
})
export class ReportCardContributionComponent {
  constructor(protected userService: UserRoleService) {}
}
